<script>
export default {
  props: {
    text: { type: String, required: true },
    query: { type: String, default: null }
  },
  render (createElement) {
    const keywords = this.query
      .trim()
      .split(' ')
      .filter(keyword => keyword.length > 0)
      .sort((a, b) => b.length - a.length)

    const children = []
    let seekIdx = 0

    keywords.forEach(keyword => {
      const matchIdx = this.text.toLowerCase().indexOf(keyword.toLowerCase())

      if (matchIdx !== -1 && matchIdx >= seekIdx) {
        if (matchIdx > seekIdx) {
          children.push(this.text.substring(seekIdx, matchIdx))
        }

        children.push(createElement('mark', [this.text.substring(matchIdx, matchIdx + keyword.length)]))
        seekIdx = matchIdx + keyword.length
      }
    })

    if (seekIdx < this.text.length) {
      children.push(this.text.substring(seekIdx, this.text.length))
    }

    return createElement('span', children)
  }
}
</script>

<style scoped>
mark {
  padding: 2px;
  background: blue;
  color: white;
  border-radius: 5px;
}
</style>
